import { BadgeCheck } from "lucide-react";
import FadeIn from "@/components/FadeIn";

const STEPS = [
  {
    n: "01",
    title: "Votre simulation en ligne",
    text: "2 minutes suffisent pour estimer vos aides et vérifier votre éligibilité.",
  },
  {
    n: "02",
    title: "La visite technique",
    text: "Un technicien RGE évalue votre logement, votre chauffage actuel et vos émetteurs pour bien dimensionner la pompe à chaleur.",
  },
  {
    n: "03",
    title: "Dossier d'aides & devis",
    text: "Nous montons et déposons vos demandes MaPrimeRénov' et CEE, avant la signature du devis. Zéro paperasse pour vous.",
  },
  {
    n: "04",
    title: "Installation & mise en service",
    text: "Nos artisans certifiés RGE QualiPAC installent votre pompe à chaleur, la mettent en service et vous expliquent tout.",
  },
];

const PROCESS_IMG = "/pac-produit.webp";

export default function Process() {
  return (
    <section
      id="methode"
      data-testid="section-methode"
      className="relative bg-forest-dark py-24 sm:py-32"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <FadeIn>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-emerald-300 sm:text-xs">
            Notre méthode
          </p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-5xl">
            Un projet clé en main, du simulateur à la mise en service.
          </h2>
          <div className="relative mt-12 space-y-10 before:absolute before:left-[19px] before:top-2 before:h-[calc(100%-16px)] before:w-px before:bg-white/10">
            {STEPS.map((s, i) => (
              <FadeIn key={s.n} delay={i * 0.08}>
                <div className="relative flex gap-6" data-testid={`process-step-${i + 1}`}>
                  <span className="z-10 grid h-10 w-10 shrink-0 place-items-center rounded-full border border-emerald-400/40 bg-forest-dark font-mono text-xs font-semibold text-emerald-300">
                    {s.n}
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-bold text-white">
                      {s.title}
                    </h3>
                    <p className="mt-2 max-w-md text-sm leading-relaxed text-white/60">
                      {s.text}
                    </p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </FadeIn>

        <FadeIn delay={0.15}>
          <div className="relative">
            <div className="absolute inset-0 -translate-x-3 translate-y-3 rounded-2xl border border-emerald-400/30" />
            <div className="group relative overflow-hidden rounded-2xl">
              <img
                src={PROCESS_IMG}
                alt="Pompe à chaleur air/eau Alfea Excellia S Duo — unité extérieure et module intérieur"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-105 sm:aspect-[4/4]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/60 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-center gap-3 rounded-2xl border border-white/15 bg-forest-deep/80 px-5 py-4 backdrop-blur-xl">
                <BadgeCheck className="h-6 w-6 shrink-0 text-emerald-400" />
                <p className="text-sm font-semibold leading-snug text-white">
                  Installateur certifié RGE QualiPAC & QualiPV
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
